import React from 'react';
function SmsFailedOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z" }),
        React.createElement("path", { d: "M11 12h2v2h-2zM11 6h2v4h-2z" })));
}
export default SmsFailedOutlined;
